import { defineComponent as _defineComponent } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode } from "vue";
const _hoisted_1 = { class: "grid grid-flow-col gap-x-5 gap-y-5 lg:grid-rows-3 xl:grid-rows-1" };
const _hoisted_2 = /*#__PURE__*/ _createElementVNode("hr", { class: "mt-6 border-0 h-px bg-gray-300" }, null, -1);
const _hoisted_3 = { class: "pt-4" };
const _hoisted_4 = /*#__PURE__*/ _createElementVNode("hr", { class: "mt-6 border-0 h-px bg-gray-300" }, null, -1);
const _hoisted_5 = {
    key: 0,
    class: "pt-4"
};
import { computed, onMounted, ref } from 'vue';
import { useStore } from 'vuex';
import httpClient from '@/httpClient';
import OutstandingRequests from './elements/OutstandingRequests.vue';
import OutstandingWork from './elements/OutstandingWork.vue';
import ProcessedWork from './elements/ProcessedWork.vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'H2rDashboard',
    setup(__props) {
        const store = useStore();
        const user = computed(() => store.getters.getProfile);
        const overall = ref({
            OFFER: [0, 0, 0, 0, 0, 0],
            LEAVER: [0, 0, 0, 0, 0, 0],
            AMEND: [0, 0, 0, 0, 0, 0],
        });
        const users = ref({});
        const processedOverall = ref({
            OFFER: [0, 0, 0, 0, 0, 0],
            LEAVER: [0, 0, 0, 0, 0, 0],
            AMEND: [0, 0, 0, 0, 0, 0],
        });
        const processedUsers = ref({});
        const dates = ref({
            startDate: null,
            endDate: null,
        });
        const handleDateChange = ({ formData }) => {
            dates.value = formData;
        };
        const handleSearchProcessed = async () => {
            const processedResponse = await httpClient.post(`/dashboard/total-processed`, {
                requestedBy: user.value.userID,
                startDate: dates.value.startDate,
                endDate: dates.value.endDate,
            });
            const processedBody = processedResponse.data.body;
            processedOverall.value = processedBody.overall;
            processedUsers.value = processedBody.users ?? {};
        };
        onMounted(async () => {
            const response = await httpClient.post(`/dashboard/total-outstanding`, {
                requestedBy: user.value.userID,
            });
            const body = response.data.body;
            overall.value = body.overall;
            users.value = body.users ?? {};
            const processedResponse = await httpClient.post(`/dashboard/total-processed`, { requestedBy: user.value.userID });
            const processedBody = processedResponse.data.body;
            processedOverall.value = processedBody.overall;
            processedUsers.value = processedBody.users ?? {};
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createElementVNode("section", null, [
                    _createElementVNode("div", _hoisted_1, [
                        (overall.value)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, _renderList([
                                { title: 'Offers', type: 'OFFER' },
                                { title: 'Amends', type: 'AMEND' },
                                { title: 'Leavers', type: 'LEAVER' },
                            ], (document) => {
                                return _createVNode(OutstandingRequests, {
                                    key: document.title,
                                    title: document.title,
                                    data: overall.value[document.type]
                                }, null, 8, ["title", "data"]);
                            }), 64))
                            : _createCommentVNode("", true)
                    ])
                ]),
                _createTextVNode(),
                _hoisted_2,
                _createTextVNode(),
                _createElementVNode("section", _hoisted_3, [
                    _createVNode(OutstandingWork, { users: users.value }, null, 8, ["users"])
                ]),
                _createTextVNode(),
                _hoisted_4,
                _createTextVNode(),
                (processedOverall.value)
                    ? (_openBlock(), _createElementBlock("section", _hoisted_5, [
                        _createVNode(ProcessedWork, {
                            users: processedUsers.value,
                            overall: processedOverall.value,
                            "form-data": dates.value,
                            "onUpdate:formData": handleDateChange,
                            onSearchProcessed: handleSearchProcessed
                        }, null, 8, ["users", "overall", "form-data"])
                    ]))
                    : _createCommentVNode("", true)
            ], 64));
        };
    }
});
